/* Turning Hearts memorial wall, round 3.
   - Posts, "Today we remember" and anniversaries come from the app's public wall
     address and are built here with text only (never HTML from the feed).
   - A visitor's last copy is kept in their browser so a return visit shows posts
     at once while fresh ones load.
   - Product posts ("Turning Hearts") sit after fixed post numbers.
   - Live memorial search from the app's own search as the visitor types, plus
     graves on a cemetery's plot list that have no memorial yet.
   No libraries. Nothing here holds up the page from showing. */
(function () {
  'use strict';

  /* ---------- small safe helpers ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null && text !== '') n.textContent = String(text);
    return n;
  }
  function safeUrl(u) {
    if (typeof u !== 'string') return '';
    u = u.trim();
    return /^https:\/\//i.test(u) || /^\/(?![\/\\])/.test(u) ? u : '';
  }
  function isHttps(u) { return typeof u === 'string' && /^https:\/\//i.test(u.trim()); }
  // Photos from the app are loaded straight away (lazy loading left some of
  // them empty), and each gets one retry before falling back.
  function img(src, alt, w, h, cls, lazy) {
    var i = document.createElement('img');
    if (lazy) i.loading = 'lazy';
    i.decoding = 'async'; i.alt = alt || '';
    if (w) i.width = w; if (h) i.height = h; if (cls) i.className = cls;
    i.src = src;
    return i;
  }
  function onFail(i, fallback) {
    var tried = false;
    i.addEventListener('error', function () {
      if (!tried) { tried = true; var s = i.src; i.src = s + (s.indexOf('?') > -1 ? '&' : '?') + 'r=1'; return; }
      fallback();
    });
  }
  function link(href, cls, text) {
    var a = el('a', cls, text); a.href = safeUrl(href) || '#'; return a;
  }
  function store(key, val) {
    try { if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null'); localStorage.setItem(key, JSON.stringify(val)); } catch (e) { return null; }
    return null;
  }
  function initialsSpan(text, cls) { return el('span', cls, String(text || 'TH').slice(0, 3)); }

  /* ---------- one post ---------- */
  function buildPost(p) {
    var m = p.memorial || {};
    var url = safeUrl(p.url) || '#';
    var art = el('article', 'th-post');
    art.setAttribute('data-th-memorial', String(m.id || ''));
    var hasCover = isHttps(m.cover);
    var later = count >= 3;

    if (hasCover) {
      var cov = el('div', 'th-post__cover');
      var cl = link(url, 'th-post__coverlink');
      cl.setAttribute('tabindex', '-1'); cl.setAttribute('aria-hidden', 'true');
      var ci = img(m.cover, '', 800, 220);
      if (later) ci.fetchPriority = 'low';
      // While the photo loads, the cover shows the soft loading shimmer, so it
      // reads as loading rather than empty. A family cover that won't load (a
      // missing file) switches to the built-in cover the app sends with it;
      // only if that fails too does the plain box show.
      cov.classList.add('th-sk', 'th-sk--cover');
      var backup = isHttps(m.cover_fallback) && m.cover_fallback !== m.cover ? m.cover_fallback : '';
      ci.addEventListener('load', function () { cov.classList.remove('th-sk', 'th-sk--cover'); });
      onFail(ci, function () {
        if (backup) { var b = backup; backup = ''; ci.src = b; return; }
        cov.classList.remove('th-sk', 'th-sk--cover');
        cov.classList.add('th-post__cover--plain'); ci.remove();
      });
      cl.appendChild(ci);
      cov.appendChild(cl);
      if (p.badge) cov.appendChild(el('span', 'th-badge' + (/VETERAN/.test(p.badge) ? ' th-badge--navy' : ''), p.badge));
      art.appendChild(cov);
    } else if (p.badge) {
      var bl = el('div', 'th-post__badgeline');
      bl.appendChild(el('span', 'th-badge th-badge--inline', p.badge));
      art.appendChild(bl);
    }

    var body = el('div', 'th-post__body');
    var head = el('div', 'th-post__head' + (hasCover ? ' th-post__head--over' : ''));
    var av = link(url, 'th-avatar');
    av.setAttribute('tabindex', '-1'); av.setAttribute('aria-hidden', 'true');
    if (isHttps(m.avatar)) {
      var ai = img(m.avatar, '', 88, 88);
      if (later) ai.fetchPriority = 'low';
      onFail(ai, function () { av.replaceChildren(initialsSpan(m.initials)); });
      av.appendChild(ai);
    } else {
      av.appendChild(initialsSpan(m.initials));
    }
    head.appendChild(av);
    var id = el('div', 'th-post__id');
    id.appendChild(link(url, 'th-post__name', m.name || ''));
    var line = [m.years, m.place].filter(Boolean).join(' · ');
    if (line) id.appendChild(el('div', 'th-muted', line));
    head.appendChild(id);
    body.appendChild(head);

    if (p.actor || p.action) {
      var who = el('p', 'th-post__who');
      who.appendChild(el('strong', '', p.actor || 'A family member'));
      who.appendChild(document.createTextNode(' ' + (p.action || '')));
      if (p.when) who.appendChild(el('span', 'th-muted', ' · ' + p.when));
      body.appendChild(who);
    }
    if (p.title || p.text) {
      var q = el('blockquote', 'th-quote');
      if (p.title) { q.appendChild(el('strong', 'th-quote__title', p.title)); }
      if (p.text) q.appendChild(el('span', 'th-quote__text', p.text));
      body.appendChild(q);
    }
    var photos = (p.photos || []).filter(isHttps).slice(0, 3);
    if (photos.length) {
      var g = el('div', 'th-photos th-photos--' + photos.length);
      photos.forEach(function (src, i) {
        var c = link(url, 'th-photos__cell');
        var pi = img(src, 'Photo shared on ' + (m.name || 'this') + "'s memorial", 700, 525, null, true);
        onFail(pi, function () { c.remove(); if (!g.children.length) g.remove(); });
        c.appendChild(pi);
        if (i === photos.length - 1 && p.more_photos > 0) c.appendChild(el('span', 'th-photos__more', '+' + p.more_photos));
        g.appendChild(c);
      });
      body.appendChild(g);
    }
    art.appendChild(body);

    var acts = el('div', 'th-post__actions');
    var bday = p.badge && /BIRTHDAY/.test(p.badge);
    var narrow = window.matchMedia && window.matchMedia('(max-width: 520px)').matches;
    acts.appendChild(link(url, 'th-act th-act--love', '♡ ' + (bday ? (narrow ? 'Birthday love' : 'Send birthday love') : 'Love') + (p.loves > 0 ? ' · ' + p.loves : '')));
    acts.appendChild(link(url === '#' ? '#' : url + '#add-memory', 'th-act', 'Leave a memory'));
    var sh = link(url, 'th-act th-act--share', 'Share');
    sh.setAttribute('data-th-share', '');
    acts.appendChild(sh);
    art.appendChild(acts);
    return art;
  }

  /* ---------- the wall ---------- */
  var feed = document.querySelector('[data-th-feed]');
  if (feed) {
    var wallUrl = feed.getAttribute('data-wall-url') || '';
    var autoPages = parseInt(feed.getAttribute('data-auto-pages'), 10) || 2;
    var more = document.querySelector('[data-th-more]');
    var moreBtn = document.querySelector('[data-th-more-btn]');
    var moreLink = document.querySelector('[data-th-more-link]');
    var fail = document.querySelector('[data-th-fail]');
    var tpl = document.getElementById('th-ads');
    var ads = tpl ? Array.prototype.slice.call(tpl.content.querySelectorAll('[data-th-ad]')).map(function (n) {
      return { after: parseInt(n.getAttribute('data-after'), 10) || 0, kind: n.getAttribute('data-kind') || '', node: n.firstElementChild };
    }).filter(function (a) { return a.node; }).sort(function (a, b) { return a.after - b.after; }) : [];

    // After the fixed slots, only the shop posts repeat (never a "Coming soon" one).
    var repeatAds = ads.filter(function (a) { return a.kind === 'medallion' || a.kind === 'keychain'; });
    var seen = {}, count = 0, adIdx = 0, sinceRepeat = 0, repeatIdx = 0, page = 0, next = '1', loading = false, rendered = false;

    var clearSkeletons = function () {
      feed.querySelectorAll('.th-post--skeleton').forEach(function (n) { n.remove(); });
      feed.setAttribute('aria-busy', 'false');
    };
    var addAdsAfter = function (n) {
      // Fixed slots first, then the product posts again every 6 memories.
      var placed = false;
      while (adIdx < ads.length && ads[adIdx].after <= n) { feed.appendChild(ads[adIdx].node.cloneNode(true)); adIdx++; placed = true; }
      if (placed) { sinceRepeat = 0; return; }
      if (adIdx >= ads.length && repeatAds.length) {
        sinceRepeat++;
        if (sinceRepeat >= 6) { feed.appendChild(repeatAds[repeatIdx++ % repeatAds.length].node.cloneNode(true)); sinceRepeat = 0; }
      }
    };
    var addPosts = function (posts) {
      (posts || []).forEach(function (p) {
        var mid = p && p.memorial && p.memorial.id;
        if (!p || (mid && seen[mid])) return;
        if (mid) seen[mid] = true;
        feed.appendChild(buildPost(p));
        count++;
        addAdsAfter(count);
      });
    };
    var resetFeed = function () {
      feed.replaceChildren();
      seen = {}; count = 0; adIdx = 0; sinceRepeat = 0; repeatIdx = 0;
    };
    // If the wall can't load, the shop posts still show under the message.
    var showFail = function () {
      clearSkeletons();
      if (fail) fail.hidden = false;
      if (!feed.querySelector('.th-adpost')) repeatAds.forEach(function (a) { feed.appendChild(a.node.cloneNode(true)); });
    };
    var showEnd = function () {
      if (!more) return;
      more.hidden = false;
      var hasNext = !!next;
      if (moreBtn) moreBtn.hidden = !hasNext;
      if (moreLink) moreLink.hidden = hasNext;
    };
    // "Today we remember": only memorials with a real photo. A circle whose
    // photo won't load is removed rather than shown with initials.
    var renderToday = function (data) {
      var wrap = document.querySelector('[data-th-today]');
      var list = document.querySelector('[data-th-today-list]');
      if (!wrap || !list) return;
      var items = ((data && data.today) || []).filter(function (t) { return isHttps(t.photo); });
      if (!items.length) return;
      list.replaceChildren();
      items.slice(0, 12).forEach(function (t) {
        var a = link(t.url, 'th-circle' + (t.highlight ? ' th-circle--gold' : ''));
        var ring = el('span', 'th-circle__ring');
        var ti = img(t.photo, '', 88, 88);
        ti.fetchPriority = 'high';
        onFail(ti, function () { a.remove(); if (!list.children.length) wrap.hidden = true; });
        ring.appendChild(ti);
        a.appendChild(ring);
        a.appendChild(el('span', 'th-circle__name', t.first_name));
        a.appendChild(el('span', 'th-circle__label', t.label));
        list.appendChild(a);
      });
      wrap.hidden = false;
    };
    // Live numbers in the banner, the exact count each time ("561,816").
    var renderStats = function (data) {
      var st = data && data.stats;
      if (!st) return;
      document.querySelectorAll('[data-th-stat]').forEach(function (n) {
        var v = parseInt(st[n.getAttribute('data-th-stat')], 10);
        if (!(v > 0)) return;
        n.textContent = v.toLocaleString('en-US');
      });
    };

    var loadPage = function (fromButton) {
      if (loading || !next || !wallUrl) return;
      loading = true;
      if (moreBtn) moreBtn.disabled = true;
      var want = next;
      var u = wallUrl + (wallUrl.indexOf('?') > -1 ? '&' : '?') + 'page=' + encodeURIComponent(want);
      fetch(u, { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          loading = false;
          if (moreBtn) moreBtn.disabled = false;
          if (want === '1') {
            store('thWall1', { at: Date.now(), data: data });
            renderToday(data);
            renderStats(data);
            // Replace a cached copy only if the visitor has not started reading.
            if (rendered && window.scrollY > 300) { next = data.next || null; page = 1; showEnd(); return; }
            resetFeed();
          }
          clearSkeletons();
          addPosts(data.posts);
          rendered = true;
          page = parseInt(want, 10);
          next = data.next || null;
          if (!count) { showFail(); return; }
          if (next && page < autoPages && !fromButton) { watch(); } else { showEnd(); }
        })
        .catch(function () {
          loading = false;
          if (moreBtn) moreBtn.disabled = false;
          if (!rendered) showFail();
          else showEnd();
        });
    };

    var sentinel = el('div', 'th-sentinel');
    feed.parentNode.insertBefore(sentinel, more || null);
    var io = null;
    var watch = function () {
      if (!('IntersectionObserver' in window)) { showEnd(); return; }
      if (!io) io = new IntersectionObserver(function (e) { if (e[0].isIntersecting && next && page < autoPages) loadPage(false); }, { rootMargin: '1200px 0px' });
      io.observe(sentinel);
    };
    if (moreBtn) moreBtn.addEventListener('click', function () { loadPage(true); });

    // A return visit: show the last copy at once (up to 6 hours old; its
    // photo links are good for a day).
    var cached = store('thWall1');
    if (cached && cached.data && cached.at && Date.now() - cached.at < 21600000 && (cached.data.posts || []).length) {
      clearSkeletons();
      renderToday(cached.data);
      renderStats(cached.data);
      addPosts(cached.data.posts);
      rendered = true;
    }
    loadPage(false);
  }

  /* ---------- live memorial search ---------- */
  var form = document.querySelector('[data-th-search]');
  if (form) {
    var input = form.querySelector('input[type="search"]');
    var panel = form.querySelector('.th-search__panel');
    var api = form.getAttribute('data-search-url') || '';
    var header = document.querySelector('[data-th-header]');
    var timer = null, ctrl = null, active = -1, lastQ = '';

    var close = function () { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    var open = function () { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    var options = function () { return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]')); };
    var setActive = function (i) {
      var o = options(); if (!o.length) return;
      active = (i + o.length) % o.length;
      o.forEach(function (n, k) { n.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', o[active].id);
    };
    var marked = function (text, words) {
      var span = el('span', 'th-res__name');
      var parts = String(text || '');
      if (!words.length) { span.textContent = parts; return span; }
      var esc = words.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|');
      var re = new RegExp('(' + esc + ')', 'ig');
      parts.split(re).forEach(function (bit) {
        if (!bit) return;
        if (re.test(bit)) { span.appendChild(el('mark', '', bit)); } else { span.appendChild(document.createTextNode(bit)); }
        re.lastIndex = 0;
      });
      return span;
    };
    var year = function (d) { var m = /^(\d{4})/.exec(String(d || '')); return m ? m[1] : ''; };
    var render = function (q, data) {
      panel.replaceChildren();
      var list = (data && data.profiles) || [];
      var words = ((data && data.words) || q.split(/\s+/)).filter(function (w) { return w && w.length > 1; });
      var count = data && data.pagy && data.pagy.count;
      panel.appendChild(el('div', 'th-res__head', list.length ? ((count || list.length) + (count === 1 || list.length === 1 && !count ? ' memorial found' : ' memorials found')) : 'No memorials found yet'));
      list.slice(0, 6).forEach(function (p, i) {
        var href = safeUrl((p.profile_urls || [])[0]);
        if (!href) return;
        var a = link(href, 'th-res');
        a.id = 'th-res-' + i; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false');
        var initials = ((p.first_name || '').trim().charAt(0) + (p.last_name || '').trim().charAt(0)).toUpperCase() || 'TH';
        var face = el('span', 'th-res__face');
        if (isHttps(p.image_url)) {
          var fi = img(p.image_url, '', 56, 56);
          fi.onerror = function () { face.replaceChildren(document.createTextNode(initials)); };
          face.appendChild(fi);
        } else face.textContent = initials;
        a.appendChild(face);
        var txt = el('span', 'th-res__txt');
        txt.appendChild(marked([p.first_name, p.middle_name, p.last_name].filter(Boolean).join(' '), words));
        var yrs = [year(p.dob), year(p.dod)].filter(Boolean).join(' to ');
        var place = p.cemetery_name ? [p.cemetery_name, [p.cemetery_city, p.cemetery_state].filter(Boolean).join(', ')].filter(Boolean).join(', ') : [p.city, p.state].filter(Boolean).join(', ');
        var meta = [yrs, place].filter(Boolean).join(' · ');
        if (meta) txt.appendChild(el('span', 'th-res__meta', meta));
        a.appendChild(txt);
        panel.appendChild(a);
      });
      // Graves on a cemetery's plot list with no memorial yet (app p185): the
      // name and the cemetery only, linking to Start a memorial.
      var graves = ((data && data.graves) || []).slice(0, 5);
      if (graves.length) {
        panel.appendChild(el('div', 'th-res__head', 'Graves with no online memorial yet'));
        graves.forEach(function (g, i) {
          var href = safeUrl(g.start_url);
          if (!href || !g.name) return;
          var a = link(href, 'th-res');
          a.id = 'th-res-g' + i; a.setAttribute('role', 'option'); a.setAttribute('aria-selected', 'false');
          a.appendChild(el('span', 'th-res__face', String(g.name).trim().charAt(0).toUpperCase() || 'TH'));
          var txt = el('span', 'th-res__txt');
          txt.appendChild(marked(g.name, words));
          txt.appendChild(el('span', 'th-res__meta', (g.cemetery ? 'Buried at ' + g.cemetery + ' · ' : '') + 'Start their memorial'));
          a.appendChild(txt);
          panel.appendChild(a);
        });
      }
      var all = link(form.getAttribute('action'), 'th-res__all', 'See all results in Live memories');
      panel.appendChild(all);
      open();
    };
    var search = function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (q === lastQ && !panel.hidden) return;
      lastQ = q;
      if (ctrl && ctrl.abort) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var u = api + (api.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(q) + '&page=1&is_veteran=false';
      fetch(u, { credentials: 'omit', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) { if (input.value.trim() === q) render(q, data); })
        .catch(function (e) {
          if (e && e.name === 'AbortError') return;
          panel.replaceChildren(el('div', 'th-res__head', 'Search is busy right now.'), link(form.getAttribute('action'), 'th-res__all', 'Search in Live memories'));
          open();
        });
    };
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(search, 220); });
    input.addEventListener('focus', function () { if (panel.children.length && input.value.trim().length > 1) open(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (panel.hidden) search(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { close(); }
      else if (e.key === 'Enter') {
        var o = options();
        if (active >= 0 && o[active]) { e.preventDefault(); window.location.href = o[active].href; }
        else if (o[0]) { e.preventDefault(); window.location.href = o[0].href; }
      }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    var openBtn = document.querySelector('[data-th-search-open]');
    var closeBtn = form.querySelector('[data-th-search-close]');
    if (openBtn && header) openBtn.addEventListener('click', function () { header.classList.add('is-searching'); input.focus(); });
    if (closeBtn && header) closeBtn.addEventListener('click', function () { header.classList.remove('is-searching'); close(); });
  }

  /* ---------- phone menu ---------- */
  var drawer = document.querySelector('[data-th-drawer]');
  var menuBtn = document.querySelector('[data-th-menu-open]');
  if (drawer && menuBtn) {
    var shut = function () { drawer.hidden = true; menuBtn.setAttribute('aria-expanded', 'false'); document.body.classList.remove('th-noscroll'); menuBtn.focus(); };
    menuBtn.addEventListener('click', function () {
      drawer.hidden = false; menuBtn.setAttribute('aria-expanded', 'true'); document.body.classList.add('th-noscroll');
      var f = drawer.querySelector('a, button'); if (f) f.focus();
    });
    drawer.addEventListener('click', function (e) { if (e.target === drawer || e.target.closest('[data-th-menu-close]')) shut(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) shut(); });
  }

  /* ---------- share ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-th-share]');
    if (!a || !navigator.share) return;
    e.preventDefault();
    navigator.share({ title: 'A Turning Hearts memorial', url: a.href }).catch(function () {});
  });
})();
